import { render, staticRenderFns } from "./CalendarHours.vue?vue&type=template&id=45b9d239&scoped=true&"
import script from "./CalendarHours.vue?vue&type=script&lang=js&"
export * from "./CalendarHours.vue?vue&type=script&lang=js&"
import style0 from "./CalendarHours.vue?vue&type=style&index=0&id=45b9d239&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b9d239",
  null
  
)

export default component.exports